class TasacionesFunnelStep4 extends TasacionesFunnelManager {
    constructor() {
        super({
            stepNumber: 4,
            nextStepUrl: TasacionesConf.checkout_url || '/checkout'
        });
        
        this.formValidator = new FormValidator();
        this.priceCalculator = new PriceCalculator();
        this.initStep4Elements();

    }

    initStep4Elements() {
        this.elements = {
            form: document.getElementById('tasaciones-funnel-step-4'),
            submitBtn: document.getElementById('submit-btn-step-4'),
            priceElement: document.getElementById('tasaciones_funnel_price'),
            
            // Servicio urgente
            tasacionUrgenteRadios: document.querySelectorAll('input[name="tasacion_urgente"]'),
            
            // Contacto
            mismoContactoRadios: document.querySelectorAll('input[name="mismo_contacto"]'),
            contactoContainer: document.getElementById('mismo_contacto_container'),
            contactoNombre: document.getElementById('contacto_nombre_completo'),
            contactoTelefono: document.getElementById('contacto_telefono')
        };
        
        this.bindEvents();
        this.updatePrice();
        this.validateForm();
    }

    bindEvents() {
        // Form submit
        if (this.elements.form) {
            this.elements.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
        }

        // Servicio urgente
        if (this.elements.tasacionUrgenteRadios) {
            this.elements.tasacionUrgenteRadios.forEach(radio => {
                radio.addEventListener('change', () => {
                    this.updatePrice();
                    this.validateForm();
                });
            });
        }

        // Mismo contacto
        this.elements.mismoContactoRadios.forEach(radio => {
            radio.addEventListener('change', () => {
                const isHidden = radio.value === "1";
                if (isHidden) {
                    DOMHelpers.hide(this.elements.contactoContainer);
                } else {
                    DOMHelpers.show(this.elements.contactoContainer);
                }
                this.validateForm();
            });
        });

        // Validar formulario cada vez que un campo pierde el foco
        if (this.elements.form) {
            this.elements.form.querySelectorAll('input, select').forEach(input => {
                input.addEventListener('blur', (e) => this.validateFormField(e.target));
                input.addEventListener('keyup', () => this.validateForm());
            });
        }
    }

    updatePrice() {
        this.priceCalculator.updateStep4Price(this.elements.priceElement);
    }

    validateFormField(field) {
        // Valida el formulario cada vez que un campo pierde el foco
        const formData = new FormData();
        formData.append(field.name, field.value);

        if (field.name === 'contacto_nombre_completo' || field.name === 'contacto_telefono') {
            const requiredIfField = document.querySelector('input[name="mismo_contacto"]:checked');
            formData.append('mismo_contacto', requiredIfField.value);
        }

        this.formValidator.validateStep4(formData);

        this.validateForm();
    }

    validateForm() {
        // Validar el formulario y devolver true si es válido, false si no
        const formData = new FormData(this.elements.form);
        const errors = this.formValidator.validateStep4(formData, false);
        if (errors.length > 0) {
            this.elements.submitBtn.classList.add('disabled');
        } else {
            this.elements.submitBtn.classList.remove('disabled');
        }
        return errors.length === 0;
    }

    async handleFormSubmit(event) {
        
        // Validar los datos antes de continuar
        try {
            const formData = new FormData(this.elements.form);

            let errors = this.formValidator.validateStep4(formData);

            if (errors.length > 0) {
                event.preventDefault();
                return false;
            }

            // Al terminar la función sin event.preventDefault(); se envía el formulario.
            this.showLoading(true);
            
        } catch (error) {
            event.preventDefault();
            console.log('Error:', error);
            this.showError('Error al guardar los datos');
            return false;
        }

        return true;
    }
}

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        const instance = new TasacionesFunnelStep4();
        instance.showLoading(false);
    }
});

// Hacer la clase disponible globalmente
window.TasacionesFunnelStep4 = TasacionesFunnelStep4;